import { createFileRoute } from "@tanstack/react-router";
import landingScript from "../landing.js?url";
import landingCss from "../landing.css?url";
import { landingMarkup as generatedLandingMarkup } from "../landingMarkup";

const appWorkspaceUrl = "https://app.salesko.ai/app";
const appSignInUrl = "https://app.salesko.ai/login";
const landingMarkup = generatedLandingMarkup
  .replaceAll('class="signin" href="https://app.salesko.ai/"', `class="signin" data-auth-link="signin" href="${appSignInUrl}"`)
  .replaceAll('href="https://app.salesko.ai/"', `data-auth-link="workspace" href="${appWorkspaceUrl}"`)
  .replaceAll(
    "Connect Claude or any MCP client. Your contacts and events become agent-native tools the model can read, query, and act on.",
    "MCP access is included on Pro and Business. Connect Claude or any MCP client to query your relationship graph from an external agent."
  )
  .replaceAll("Connect your agent", "View Pro plans")
  .replaceAll('href="#channels" data-i18n="cta.btn2"', 'href="#pricing" data-i18n="cta.btn2"')
  .replaceAll(
    "Start free with the graph. Unlock Deep Research when you're ready — bring your own key, or let Salesko manage it for you.",
    "Start free with the graph and daily Generic Agent. Pro raises the Generic Agent quota and unlocks MCP; Business adds Salesko-managed Deep Research."
  )
  .replaceAll("Pro · BYOK", "Pro")
  .replaceAll(
    "Higher Generic Agent quota, plus Deep Research on your own provider key.",
    "Higher Generic Agent quota, MCP access, and Deep Research with your own provider key when needed."
  )
  .replaceAll("Deep Research — bring your own LLM key", "MCP access for external agents")
  .replaceAll("No SalesKo credit limit on Deep Research", "Deep Research can use your provider key")
  .replaceAll(
    "Unlimited Generic Agent, Deep Research fully managed by Salesko.",
    "Unlimited Generic Agent, MCP access, and Deep Research fully managed by Salesko."
  )
  .replaceAll("No key management needed", "MCP access plus no key management");

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Salesko - Your next opportunity is hiding in people you already know" },
      {
        name: "description",
        content:
          "Salesko turns your raw meeting notes, in any language, into a living graph of people, companies, events, and the opportunities hiding between them. Agent-native, MCP-ready."
      },
      { property: "og:title", content: "Salesko - Contacts Intelligence" },
      { property: "og:description", content: "Your next opportunity is hiding in people you already know." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://salesko.ai/" }
    ],
    links: [
      { rel: "canonical", href: "https://salesko.ai/" },
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@400;500;600;700;800&family=IBM+Plex+Mono:wght@400;500;600&family=Source+Serif+4:opsz,wght@8..60,600;8..60,700&display=swap"
      },
      { rel: "stylesheet", href: landingCss }
    ]
  }),
  component: LandingRoute
});

function LandingRoute() {
  return (
    <>
      {/* landing.js progressively enhances this static markup (adds js-reveal,
          recomputes the Pretext badge, toggles language) before React finishes
          hydrating, so the SSR string and the post-script DOM intentionally diverge. */}
      <div suppressHydrationWarning dangerouslySetInnerHTML={{ __html: landingMarkup }} />
      {/* dev-only: Vite appends a ?t= HMR cache-buster the SSR string lacks */}
      <script suppressHydrationWarning type="module" src={landingScript} />
    </>
  );
}
